import type { FormInputType, FormOnValidate, FormValues } from '@/components/UI/Form/types'

// Helper to create an input and validator function that can be used to prompt user for
// confirmation.
export default function getConfirmationFormInput(
  label: string,
  confirmationText: string
): [FormInput: FormInputType, handleValidate: FormOnValidate] {
  const FormInput: FormInputType = {
    label,
    sublabel: `Write "${confirmationText}" without the quotes`,
    type: 'text',
    name: 'confirmation',
    placeholder: confirmationText,
    required: true,
    size: 6,
  }

  const handleValidate = (values: FormValues) => {
    if (values.confirmation !== confirmationText) {
      return {
        errors: {
          confirmation: `The confirmation text should be "${confirmationText}" without the quotes`,
        },
        message: 'Please enter the confirmation text correctly',
      }
    }
    return null
  }
  return [FormInput, handleValidate]
}
